import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import PrivateRoute from 'components/Router/PrivateRoute';
import PublicRoute from 'components/Router/PublicRoute';
import Layout from '../layout';
import Sidebar from '../sidebar';
import builder_routes from '../Builders/routes';
import clients_routes from '../Subcontractors/routes';
import auth_routes from '../Auth/routes';
import user_routes from '../User/routes';
import trade_routes from '../Trades/routes';
import items_routes from '../Items/routes';
import room_routes from '../Rooms/routes';
import search_routes from '../Search/routes';
import manage_roles from '../Manage-Roles/routes';
import auth from '../Auth/authenticator';
import ManageBuilders from '../Builders/Containers/manage-builders';
import ManageSubcontractors from '../Subcontractors/Containers/manage-subcontractors';
import MyProfile from '../User/Containers/my-profile';
import { checkRoute, checkAllSystemRoute } from '../helper/check-route-helper';
import { AppSettings } from '../constants';
import NotFoundPage from 'errorPage/404';
import AccessDeniedPage from 'errorPage/403';
import default_config from '../DefaultConfig/routers'

class AppRoutes extends React.Component {
  static propTypes = {
    history: PropTypes.any,
    authenticated: PropTypes.bool,
    location: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  renderRoutes = roleName => {
    let routes = [];

    if (roleName === AppSettings.SYSTEM_ADMINISTRATOR) {
      routes = [].concat(
        auth_routes,
        search_routes,
        builder_routes,
        clients_routes,
        user_routes,
        trade_routes,
        items_routes,
        room_routes,
        manage_roles,
        default_config
      );

      routes.push({
        path: '/',
        component: ManageBuilders,
        private: true
      });
    }
    else {
      routes = [].concat(
        auth_routes,
        search_routes,
        builder_routes,
        clients_routes,
      );

      routes.push({
        path: '/my-profile',
        component: MyProfile,
        private: true
      });

      routes.push({
        path: '/',
        component: ManageSubcontractors,
        private: true
      });
    }

    return routes;
  };

  renderSidebar = (roleName, routes) => {
    let groupMenu = null;

    if (roleName === AppSettings.SYSTEM_ADMINISTRATOR) {
      groupMenu = [
        {
          group: 'Admin',
          icon: 'icon-admin-ultilities-ic',
          name: 'Admin utilities',
          subGroup: [
            { key: 'General', name: 'General' },
            { key: 'Other', name: 'Other' }
          ],
          menu: {
            isGroup: true,
            order: 8
          }
        }
      ];
    }
    else {
      groupMenu = [
        {
          group: 'Report',
          icon: 'pe-7s-graph3',
          name: 'Reports management',
          menu: {
            isGroup: true,
            order: 7
          }
        }
      ];
    }

    return (
      <Sidebar
        key='sidebar'
        routes={routes}
        groupMenu={groupMenu}
        location={this.props.location}
      />
    );
  };
  render() {
    const authenticated = auth.loggedIn();
    const roleName = auth.getRoleName();
    var routes = this.renderRoutes(roleName);
    let privateRoute = null;
    let publicRoute = null;

    const matchRoute = checkRoute(routes, this.props.location.pathname);

    if (matchRoute) {
      if (matchRoute.private) {
        privateRoute = matchRoute;
      } else {
        publicRoute = matchRoute;
      }
    }

    const nextUrl = this.props.location.pathname;

    const queryParams = new URLSearchParams(this.props.location.search);
    const isPublic = queryParams.get('public');

    if (privateRoute) {
      if (!localStorage[AppSettings.S1_TOKEN]) {
        if (isPublic || isPublic === 'true') {
          return (
            <Redirect to={`/public${nextUrl}${this.props.location.search}`} />
          );
        } else {
          return (
            <Redirect
              to={`/sign-in?nextUrl=${nextUrl}${this.props.location.search}`}
            />
          );
        }
      }

      return (
        <Layout
          history={this.props.history}
          routes={routes}
          location={this.props.location}
          renderSidebar={() => this.renderSidebar(roleName, routes)}
        >
          <PrivateRoute
            authed={authenticated}
            component={privateRoute.component}
            exact
            path={privateRoute.path}
            key={'private'}
          />
        </Layout>
      );
    }
    if (publicRoute) {
      return (
        <PublicRoute
          authed={authenticated}
          component={publicRoute.component}
          exact
          path={publicRoute.path}
          key={'private'}
        />
      );
    }

    if (!authenticated) {
      return (
        <Redirect
          to={`/sign-in?nextUrl=${nextUrl}${this.props.location.search}`}
        />
      );
    }

    if (checkAllSystemRoute(this.props.location.pathname)) {
      return <AccessDeniedPage />;
    }

    return <NotFoundPage />;
  }
}

/*eslint-disable */
export default withRouter(AppRoutes);
/*eslint-enable */



// WEBPACK FOOTER //
// ./src/portal_system/router.js